var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 60 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0C13.4315 0 0 13.5258 0 30.0943C0 39.3578 4.19854 47.6701 10.7965 53.1991C17.8096 54.7089 28.723 55.8523 35.8297 50.7666C41.5384 46.6813 50.142 44.2195 57.198 42.7882C58.9959 38.9273 60 34.6245 60 30.0943C60 13.5258 46.5685 0 30 0Z",
    fill: "#1DA1F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_422_3967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0C13.4315 0 0 13.5258 0 30.0943C0 39.3578 4.19854 47.6701 10.7965 53.1991C17.8096 54.7089 28.723 55.8523 35.8297 50.7666C41.5384 46.6813 50.142 44.2195 57.198 42.7882C58.9959 38.9273 60 34.6245 60 30.0943C60 13.5258 46.5685 0 30 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_422_3967)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4978 32.6887H19.503C19.0155 32.6887 18.6211 33.1543 18.6211 33.7265C18.6211 34.3001 19.0168 34.7642 19.503 34.7642H25.4978C25.9853 34.7642 26.3797 34.2986 26.3797 33.7265C26.3797 33.1543 25.9865 32.6887 25.4978 32.6887Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5455 36.8396H17.3837C16.9233 36.8396 16.5508 37.3037 16.5508 37.8773C16.5508 38.4509 16.9245 38.9151 17.3837 38.9151H25.5455C26.0059 38.9151 26.3784 38.4495 26.3784 37.8773C26.3784 37.3023 26.007 36.8396 25.5455 36.8396Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4034 20.0713C43.6024 19.8286 43.5716 19.4675 43.3347 19.2646L41.6785 17.8481C41.4404 17.6452 41.0861 17.6766 40.8883 17.9193L38.9762 20.2416C37.3958 19.0641 35.5312 18.2719 33.5028 17.9869L33.5016 15.9279H35.9433C36.217 15.9279 36.4397 15.7021 36.4397 15.4219V13.4777C36.4397 13.1987 36.2181 12.9717 35.9433 12.9717L27.7628 12.9729C27.4892 12.9729 27.2664 13.1987 27.2664 13.4789V15.4231C27.2664 15.7021 27.488 15.9291 27.7628 15.9291H30.2045V17.9797C28.1953 18.2586 26.3188 19.0436 24.7217 20.2306L22.8191 17.9205C22.6201 17.6777 22.2671 17.6463 22.0289 17.8492L20.3727 19.2657C20.1346 19.4686 20.1038 19.8297 20.304 20.0724L22.35 22.5577C21.6889 23.4127 21.1262 24.3607 20.6962 25.3992C20.4841 25.9076 20.7175 26.4958 21.2186 26.7119C21.7197 26.9293 22.2943 26.689 22.5064 26.1794C24.0986 22.3428 27.7678 19.8634 31.8548 19.8634C37.4477 19.8634 41.9993 24.5019 41.9993 30.2042C41.9993 35.9052 37.4477 40.5437 31.8548 40.5437C30.2187 40.5437 28.6597 40.1597 27.2167 39.4037C26.7357 39.1501 26.1422 39.3433 25.8934 39.8348C25.6446 40.3263 25.8341 40.9301 26.3163 41.1837C28.0152 42.0762 29.9308 42.5471 31.8549 42.5471C38.532 42.5471 43.965 37.0103 43.965 30.2028C43.9638 27.3202 42.9817 24.6705 41.3492 22.5659L43.4034 20.0713Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.377 30.338C37.7187 26.3502 37.9183 25.1976 37.6924 24.9711C37.4652 24.7444 36.3174 24.9435 32.3422 28.2968C30.4508 29.8919 31.0462 30.8071 31.4599 31.222C31.8748 31.6382 32.787 32.2355 34.3771 30.3381L34.377 30.338Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3789 29.0565C26.3789 28.4829 25.9916 28.0188 25.5129 28.0188H15.3485C14.8698 28.0188 14.4824 28.4844 14.4824 29.0565C14.4824 29.6302 14.8698 30.0943 15.3485 30.0943H25.5141C25.9928 30.0943 26.379 29.6301 26.379 29.0565H26.3789Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingResearch);
export default __webpack_public_path__ + "static/media/landing_research.abebff97e8a63d10200d1ffe49ca6be9.svg";
export { ForwardRef as ReactComponent };